import { Empty as EmptyAntd } from 'antd';
import { useTranslation } from 'react-i18next';

const Empty = ({ ...props }) => {
  const { t } = useTranslation();
  return (
    <EmptyAntd
      description={
        <span className="text-body-medium text-black-medium">
          {t('No matching products found.')}
        </span>
      }
      image={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="160"
          height="160"
          viewBox="0 0 160 160"
          fill="none"
        >
          <path
            d="M88.401 70.6689L81.1118 86.2812L116.42 96.5688L124.382 78.837L88.401 70.6689Z"
            fill="url(#paint0_linear_11101_191755)"
          />
          <path
            d="M70.7207 71.5996L81.1117 86.2814L43.6319 98.3783L33.396 82.6626L70.7207 71.5996Z"
            fill="url(#paint1_linear_11101_191755)"
          />
          <path
            d="M81.1116 86.2812V130.585L44.9242 142.165L43.6318 98.3782L81.1116 86.2812Z"
            fill="url(#paint2_linear_11101_191755)"
          />
          <path
            d="M43.6318 98.3779L44.9242 142.165L78.5268 152.607V108.304L43.6318 98.3779Z"
            fill="url(#paint3_linear_11101_191755)"
          />
          <path
            d="M81.1118 130.585L115.128 140.356L116.42 96.5688L81.1118 86.2812V130.585Z"
            fill="url(#paint4_linear_11101_191755)"
          />
          <path
            d="M43.6321 98.3779L36.0327 116.42L70.3074 127.328L78.5271 108.304L43.6321 98.3779Z"
            fill="url(#paint5_linear_11101_191755)"
          />
          <path
            d="M78.5268 108.304V108.51L70.3588 127.431L70.3071 127.328L78.5268 108.304Z"
            fill="#EBEBEB"
          />
          <path
            d="M36.0327 116.42L36.1361 116.523L70.3591 127.431L70.3074 127.328L36.0327 116.42Z"
            fill="#EBEBEB"
          />
          <path
            d="M116.42 96.5693L115.128 140.356L78.5269 152.608V108.304L116.42 96.5693Z"
            fill="url(#paint6_linear_11101_191755)"
          />
          <path
            d="M125.674 34.7402C117.713 45.3897 119.625 44.7176 116.524 51.3347C110.32 64.4139 108.666 72.8404 100.963 75.7871C96.1553 77.6482 89.4348 77.1312 86.1262 73.1506C81.8871 67.9809 84.0067 57.7968 90.6238 53.9713C96.9307 50.3008 104.789 53.8679 108.666 58.0036C115.49 65.2927 113.784 78.4753 107.735 84.6788C101.894 90.6756 94.1908 87.8323 90.8306 93.2604C87.8322 98.0682 90.7272 105.409 94.1391 111.561"
            stroke="#EBEBEB"
            stroke-width="1.2184"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="5.08 5.08"
          />
          <path
            d="M116.42 96.5693L125.777 113.009L88.4525 125.468L78.5269 108.304L116.42 96.5693Z"
            fill="url(#paint7_linear_11101_191755)"
          />
          <path
            d="M78.5269 108.304V108.51L88.4008 125.622L88.4525 125.467L78.5269 108.304Z"
            fill="#EBEBEB"
          />
          <path
            d="M88.4009 125.623L125.777 113.216V113.009L88.4526 125.468L88.4009 125.623Z"
            fill="#EBEBEB"
          />
          <path
            d="M124.382 78.8369V78.992L116.472 96.6721L116.42 96.5687L124.382 78.8369Z"
            fill="#EBEBEB"
          />
          <path
            d="M33.396 82.6631V82.8182L43.6319 98.4305V98.3788L33.396 82.6631Z"
            fill="#EBEBEB"
          />
          <path
            opacity="0.33"
            d="M78.5268 143.044C78.5268 143.044 92.795 140.045 102.152 133.893C113.008 126.759 115.8 117.402 115.8 117.402L115.128 140.407L78.4751 152.608V143.044H78.5268Z"
            fill="#EBEBEB"
          />
          <path
            opacity="0.33"
            d="M44.9243 142.165L44.8726 140.355L78.5268 143.044V152.607L44.9243 142.165Z"
            fill="#D6D6D6"
          />
          <path
            opacity="0.33"
            d="M44.9243 142.165L78.5269 151.47V152.608L44.9243 142.165Z"
            fill="#D6D6D6"
          />
          <path
            opacity="0.33"
            d="M78.5269 151.471L115.18 138.185L115.128 140.356L78.5269 152.608V151.471Z"
            fill="#EBEBEB"
          />
          <path
            d="M35.2568 8.53027C44.1486 16.8017 54.1777 28.7435 52.0581 40.8921C49.9903 52.5238 38.2035 56.0909 37.4281 66.3784C36.9628 72.9438 40.9434 82.7661 62.6042 95.897"
            stroke="#EBEBEB"
            stroke-width="1.5537"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="6.47 6.47"
          />
          <path
            d="M53.8158 27.4511L27.4507 11.0117L43.7867 29.002L53.8158 27.4511Z"
            fill="url(#paint8_linear_11101_191755)"
          />
          <path
            d="M27.4509 11.0117L27.1924 32.6725L39.7546 29.6224L27.4509 11.0117Z"
            fill="url(#paint9_linear_11101_191755)"
          />
          <path
            d="M43.7867 29.002L39.7027 36.9633L39.7544 29.6224L27.4507 11.0117L43.7867 29.002Z"
            fill="#D6D6D6"
          />
          <path
            d="M39.7028 36.9629L34.895 30.8111L39.7545 29.6221L39.7028 36.9629Z"
            fill="#BBBBBB"
          />
          <path
            d="M42.7529 63.9478L61.7772 59.502L48.3878 66.8945L42.7529 63.9478Z"
            fill="url(#paint10_linear_11101_191755)"
          />
          <path
            d="M61.7773 59.502L57.5382 72.4777L50.6626 68.0835L61.7773 59.502Z"
            fill="url(#paint11_linear_11101_191755)"
          />
          <path
            d="M48.3877 66.8945L49.1631 72.4777L50.6623 68.0835L61.777 59.502L48.3877 66.8945Z"
            fill="#D6D6D6"
          />
          <path
            d="M49.1631 72.4782L53.2988 69.79L50.6623 68.084L49.1631 72.4782Z"
            fill="#BBBBBB"
          />
          <path
            d="M119.832 27.4502L130.998 20.1094L124.123 27.9672L119.832 27.4502Z"
            fill="url(#paint12_linear_11101_191755)"
          />
          <path
            d="M130.998 20.1094L131.308 29.4147L125.88 28.2257L130.998 20.1094Z"
            fill="url(#paint13_linear_11101_191755)"
          />
          <path
            d="M124.123 27.9672L125.984 31.3792L125.881 28.2257L130.999 20.1094L124.123 27.9672Z"
            fill="#D6D6D6"
          />
          <path
            d="M125.984 31.3791L128 28.6909L125.88 28.2256L125.984 31.3791Z"
            fill="#BBBBBB"
          />
          <path
            d="M130.068 61.3631L111.199 48.9043L122.727 62.2936L130.068 61.3631Z"
            fill="url(#paint14_linear_11101_191755)"
          />
          <path
            d="M111.199 48.9043L110.63 64.62L119.832 62.6555L111.199 48.9043Z"
            fill="url(#paint15_linear_11101_191755)"
          />
          <path
            d="M122.727 62.2936L119.625 67.9802L119.832 62.6555L111.199 48.9043L122.727 62.2936Z"
            fill="#D6D6D6"
          />
          <path
            d="M119.625 67.98L116.265 63.4307L119.832 62.6553L119.625 67.98Z"
            fill="#BBBBBB"
          />
          <defs>
            <linearGradient
              id="paint0_linear_11101_191755"
              x1="113.763"
              y1="88.8672"
              x2="74.0942"
              y2="66.1822"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F6F6F6" />
              <stop offset="1" stop-color="#EBEBEB" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_11101_191755"
              x1="59.004"
              y1="87.5941"
              x2="67.5102"
              y2="102.629"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F6F6F6" />
              <stop offset="1" stop-color="#EBEBEB" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_11101_191755"
              x1="62.3992"
              y1="93.8446"
              x2="63.3745"
              y2="132.857"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#EBEBEB" />
              <stop offset="1" stop-color="#BBBBBB" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_11101_191755"
              x1="38.5466"
              y1="120.456"
              x2="115.146"
              y2="137.528"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#EBEBEB" />
              <stop offset="0.9718" stop-color="#F6F6F6" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_11101_191755"
              x1="88.5217"
              y1="80.3699"
              x2="102.875"
              y2="126.92"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#EBEBEB" />
              <stop offset="0.9718" stop-color="#BBBBBB" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_11101_191755"
              x1="33.7212"
              y1="111.034"
              x2="71.9109"
              y2="114.02"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#EBEBEB" />
              <stop offset="0.9718" stop-color="#F6F6F6" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_11101_191755"
              x1="97.6912"
              y1="75.3172"
              x2="97.3164"
              y2="121.263"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#D6D6D6" />
              <stop offset="0.9718" stop-color="#F6F6F6" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_11101_191755"
              x1="85.4251"
              y1="64.9545"
              x2="101.39"
              y2="108.586"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#D6D6D6" />
              <stop offset="1" stop-color="#F6F6F6" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_11101_191755"
              x1="25.5709"
              y1="16.5848"
              x2="54.2217"
              y2="26.3864"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F6F6F6" />
              <stop offset="1" stop-color="#EBEBEB" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_11101_191755"
              x1="28.3367"
              y1="11.0628"
              x2="34.9823"
              y2="36.9122"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F6F6F6" />
              <stop offset="1" stop-color="#EBEBEB" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_11101_191755"
              x1="61.7795"
              y1="63.2092"
              x2="42.7327"
              y2="63.2092"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F6F6F6" />
              <stop offset="1" stop-color="#EBEBEB" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_11101_191755"
              x1="61.2581"
              y1="59.3597"
              x2="52.04"
              y2="73.3907"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F6F6F6" />
              <stop offset="1" stop-color="#EBEBEB" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_11101_191755"
              x1="131.85"
              y1="22.4519"
              x2="119.65"
              y2="26.9524"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F6F6F6" />
              <stop offset="1" stop-color="#EBEBEB" />
            </linearGradient>
            <linearGradient
              id="paint13_linear_11101_191755"
              x1="130.606"
              y1="20.1095"
              x2="128.017"
              y2="31.2747"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F6F6F6" />
              <stop offset="1" stop-color="#EBEBEB" />
            </linearGradient>
            <linearGradient
              id="paint14_linear_11101_191755"
              x1="109.719"
              y1="52.9094"
              x2="130.335"
              y2="60.5672"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F6F6F6" />
              <stop offset="1" stop-color="#EBEBEB" />
            </linearGradient>
            <linearGradient
              id="paint15_linear_11101_191755"
              x1="111.831"
              y1="48.9526"
              x2="116.167"
              y2="67.8454"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F6F6F6" />
              <stop offset="1" stop-color="#EBEBEB" />
            </linearGradient>
          </defs>
        </svg>
      }
      {...props}
    />
  );
};

export default Empty;
